// extracted by mini-css-extract-plugin
export var addressFields = "_m3-0";
export var animationContainer = "_m3-1";
export var footer = "_m3-2";
export var lineItems = "_m3-3";
export var modalContent = "_m3-4";
export var orderName = "_m3-5";
export var strong = "_m3-6";
export var warning = "_m3-7";